export default "__VITE_ASSET__DqDIsFdK__"